import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useWishlist } from '@/contexts/WishlistContext';
import { X } from 'lucide-react';

const CompareDrawer = () => {
  const { compareItems, removeFromCompare, isCompareOpen, setIsCompareOpen } = useWishlist();

  const allSpecs = compareItems.length > 0
    ? Object.keys(compareItems[0].specs)
    : [];

  return (
    <Sheet open={isCompareOpen} onOpenChange={setIsCompareOpen}>
      <SheetContent side="bottom" className="h-[70vh]">
        <SheetHeader>
          <SheetTitle className="font-heading">Compare Products ({compareItems.length}/3)</SheetTitle>
        </SheetHeader>

        {compareItems.length === 0 ? (
          <p className="text-center text-muted-foreground py-8">Add products to compare</p>
        ) : (
          <div className="overflow-x-auto mt-4">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b">
                  <th className="p-2 text-left text-muted-foreground">Feature</th>
                  {compareItems.map(p => (
                    <th key={p.id} className="p-2 text-center min-w-[180px]">
                      <div className="relative">
                        <Button
                          variant="ghost"
                          size="icon"
                          className="absolute -top-1 -right-1 h-6 w-6"
                          onClick={() => removeFromCompare(p.id)}
                        >
                          <X className="h-3 w-3" />
                        </Button>
                        <img src={p.image} alt={p.name} className="w-16 h-16 object-cover rounded mx-auto mb-1" />
                        <p className="font-medium text-xs">{p.name}</p>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="p-2 font-medium">Price</td>
                  {compareItems.map(p => (
                    <td key={p.id} className="p-2 text-center font-bold">₹{p.price.toLocaleString('en-IN')}</td>
                  ))}
                </tr>
                <tr className="border-b">
                  <td className="p-2 font-medium">Rating</td>
                  {compareItems.map(p => (
                    <td key={p.id} className="p-2 text-center">{p.rating} ⭐</td>
                  ))}
                </tr>
                {allSpecs.map(spec => (
                  <tr key={spec} className="border-b">
                    <td className="p-2 font-medium">{spec}</td>
                    {compareItems.map(p => (
                      <td key={p.id} className="p-2 text-center text-muted-foreground">{p.specs[spec] || '—'}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CompareDrawer;
